export function getSources(presetKeys, assetTransformations, transformationsPreset, baseUrl) {
    if (assetTransformations.length === 0) {
        return [];
    }
    const availableAssetTransformations = assetTransformations.filter((t) => presetKeys.includes(t.preset_key));
    if (availableAssetTransformations.length === 0) {
        return [];
    }
    const preSources = availableAssetTransformations.reduce((preSources, assetTransformation) => {
        // Slack (notified)[https://sentry.digitaloriginal.app/organizations/digital-original/issues/5491/?project=3&referrer=slack] about an error in this line:
        // `transformationsPreset.find` is not a function. Might be because `transformationsPreset` was not passed, or had some issue.
        // Added `?` to prevent this error.
        const presetTransformation = transformationsPreset?.find((transformation) => transformation.key === assetTransformation.preset_key);
        if (!presetTransformation) {
            console.info(`Preset transformation with key ${assetTransformation.preset_key} not found`);
            return preSources;
        }
        if (!(presetTransformation.format && presetTransformation.width)) {
            console.error(`Preset transformation with key ${assetTransformation.preset_key} is not properly created`);
            return preSources;
        }
        const { width, format } = presetTransformation;
        const filename = assetTransformation.transformation_name;
        const source = `${baseUrl}/${filename} ${width}w`;
        if (!preSources[format]) {
            preSources[format] = source;
        }
        else {
            preSources[format] += `, ${source}`;
        }
        return preSources;
    }, {});
    return Object.entries(preSources);
}
